import { axios } from '@/utils/request'

const api = {

  master: '/master/trainApplets'
}
// 列表
export function queryList(parameter) {
  return axios({
    url: api.master + '/list/web',
    method: 'get',
    params: parameter
  })
}

// 保存
export function trainUpdate(parameter) {
  return axios({
    url: api.master + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function trainEdit(parameter) {
  return axios({
    url: '/exam/trainMaterial/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 新增
export function trainSave(parameter) {
  return axios({
    url: api.master + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function trainAdd(parameter) {
  return axios({
    url: '/exam/trainMaterial/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 详情
export function getTrainInfo(id) {
  return axios({
    url: api.master + '/get',
    method: 'get',
    params: {
      id: id
    }
  })
}
export function getInfo(id) {
  return axios({
    url: '/exam/trainMaterial/get',
    method: 'get',
    params: {
      id: id
    }
  })
}
export function updateIndexIdSort(parameter) {
  return axios({
    url: '/master/trainApplets/updateIndexIdSort',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function delTrainList(parameter) {
  return axios({
    url: '/master/trainApplets/deleteTrain',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
